"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactFinalForm = require("react-final-form");

var _reactAdmin = require("react-admin");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _icons = require("@material-ui/icons");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var handleMouseDownPassword = function handleMouseDownPassword(event) {
  event.preventDefault();
};

var PasswordField = function PasswordField(_ref) {
  var isFormLoading = _ref.isFormLoading,
      fieldComponent = _ref.fieldComponent,
      label = _ref.label;
  var translate = (0, _reactAdmin.useTranslate)();

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      showPassword = _useState2[0],
      setShowPassword = _useState2[1];

  var handleClickShowPassword = function handleClickShowPassword() {
    setShowPassword(!showPassword);
  };

  return _react.default.createElement(_reactFinalForm.Field, {
    name: "password",
    type: showPassword ? 'text' : 'password',
    label: label || translate('ra.auth.password'),
    component: fieldComponent || 'input',
    disabled: isFormLoading,
    InputProps: {
      endAdornment: _react.default.createElement(_core.InputAdornment, {
        position: "end"
      }, _react.default.createElement(_core.IconButton, {
        disableRipple: true,
        "aria-label": "toggle password visibility",
        style: {
          backgroundColor: 'transparent'
        },
        onClick: handleClickShowPassword,
        onMouseDown: handleMouseDownPassword
      }, showPassword ? _react.default.createElement(_icons.Visibility, null) : _react.default.createElement(_icons.VisibilityOff, null)))
    }
  });
};

PasswordField.propTypes = {
  isFormLoading: _propTypes.default.bool,
  label: _propTypes.default.string,
  fieldComponent: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]).isRequired
};
PasswordField.defaultProps = {
  isFormLoading: false,
  label: null
};
var _default = PasswordField;
exports.default = _default;